export default function Footer() {
    return (
        <div className="footer">
            © 2025 Sigil Works. All rights reserved.
        </div>
    );
}
